import axios from 'axios';
import {buildQuery} from 'utils/QueryUtils';

export const findDiseases = (headers, params) => {
  let query = buildQuery(params);
  return axios.get(
    `${process.env.REACT_APP_CATEGORY_API_URL}/diseases${query}`,
    {
      headers,
    },
  );
};

export const findDiseaseById = (headers, id) => {
  return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/diseases/${id}`, {
    headers,
  });
};

export const createDisease = (headers, data) => {
  return axios.post(
    `${process.env.REACT_APP_CATEGORY_API_URL}/diseases`,
    data,
    {
      headers,
    },
  );
};

export const updateDisease = (headers, id, data) => {
  return axios.patch(
    `${process.env.REACT_APP_CATEGORY_API_URL}/diseases/${id}`,
    data,
    {
      headers,
    },
  );
};

export const deleteDisease = (headers, id) => {
  return axios.delete(
    `${process.env.REACT_APP_CATEGORY_API_URL}/diseases/${id}`,
    {
      headers: headers,
    },
  );
};

export const deleteDiseases = (headers, ids) => {
  return axios.delete(
    `${process.env.REACT_APP_CATEGORY_API_URL}/diseases?id=${ids.join()}`,
    {
      headers: headers,
    },
  );
};
